<template>
  <b-card>
    <donation-groups />
    <title-name />
    <notes-text />
    <report-hidden />
    <template v-if="dataItem.id_donation_groups">
      <donation-types />
    </template>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import DonationGroups from '@/views/Admin/Donation_groups/Incomes/elements/DonationGroups.vue'
import TitleName from '@/views/Admin/Donation_groups/Incomes/elements/Title.vue'
import DonationTypes from '@/views/Admin/Donation_groups/Incomes/elements/DonationTypes.vue'
import NotesText from '@/views/Admin/Donation_groups/Incomes/elements/Notes.vue'
import ReportHidden from '@/views/Admin/Donation_groups/Incomes/elements/ReportHidden.vue'

export default {
  name: 'ItemForm',
  components: {
    ReportHidden,
    BCard,
    DonationGroups,
    TitleName,
    DonationTypes,
    NotesText,
  },
  computed: {
    dataItem() {
      return this.$store.getters['donationGroups/dataItem']
    },
  },
}
</script>
